export class PalletTypeFilter {
    public IncludeInactive?: boolean;
}

export default PalletTypeFilter;